import {z} from "zod";
import en from "zod/v4/locales/en.js";
z.config(en());

const consentRecordSchemaIOSV2 = z
    .record(
        z.string(),
        z.number()
    );

const consentRecordSchemaAndroidV2 = z
    .record(
        z.string(),
        z.object({
            toggleStatus: z.union([z.number(), z.string()]),
        })
    ).transform((record) =>
        Object.fromEntries(
            Object.entries(record)
                .map(([key, vendor]) => [key, vendor.toggleStatus])
        )
    );

const consentRecordSchemaV1 = z
    .record(
        z.string(),
        z.object({
            consent: z.union([z.number(), z.string()]),
        })
    ).transform((record) =>
        Object.fromEntries(
            Object.entries(record)
                .map(([key, vendor]) => [key, vendor.consent])
        )
    );

const consentInformationSchema = z
    .object({
        consentId: z.string(),
        iabString: z.string(),
        consentData: z.union([consentRecordSchemaV1, consentRecordSchemaIOSV2, consentRecordSchemaAndroidV2]).nullable()
    });

export type ConsentInformation = z.infer<typeof consentInformationSchema>;

export const consentInformationFromObject = async function (consentInformation: Record<string, unknown>): Promise<ConsentInformation> {
    return await consentInformationSchema
        .parseAsync(consentInformation)
        .catch(error => {
            if (error instanceof z.ZodError) {
                const readableError = z.prettifyError(error);
                throw Error("Unable to parse consent information: \n" + readableError);
            }

            throw error;
        })
}

